<template>
  <div :class="[isMobile() ? 'mobile-wrapper' : '']">
    <shop-header v-if="!isMobile()" :store-id="currentStoreDoc.ID" />
    <div v-if="isMobile()" class="new-fixed-banner">
      <div class="container-fluid banner-alt" :style="styles">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack"
              >keyboard_arrow_left</span
            >
            <span class="title-text" @click="goBack">Stamps</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row justify-content-center"
      style="min-height: 80vh"
      :style="styles.pageColor"
    >
      <div class="col-lg-9 pt-4 mt-4" style="position: relative">
        <navigate-user-back v-if="!isMobile()" />
        <br /><br />
        <h2 class="text-center">{{ stampsSettings.Description }}</h2>
        <div class="stamps-container">
          <div
            v-for="index in numOfStamps + freeStamps"
            :key="index"
            :class="[
              index <= userStamps
                ? 'earned'
                : index <= numOfStamps
                ? 'gray obscure'
                : '',
            ]"
          >
            <div class="free" v-if="index > numOfStamps">
              <div>Free</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shopHeader from "../../components/shop/partials/shopheader";
import navigateUserBack from "./partials/navigateUserBack";
import common from "../../sharedscripts/Common/commonMobile.js";

import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    shopHeader,
    navigateUserBack,
  },
  mounted() {
    this.updateUserPoints();
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters([
      "currentStoreDoc",
      "styles",
      "stampsSettings",
      "userStamps",
    ]),
    numOfStamps() {
      return this.stampsSettings.StampsBuy || 0;
    },
    freeStamps() {
      return this.stampsSettings.StampsFree || 0;
    },
  },
  methods: {
    ...common.methods,
    ...mapActions(["updateUserPoints"]),
  },
};
</script>

<style lang="scss">
.stamps-container {
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  gap: 1rem;
  justify-content: center;
  margin: 40px 0 40px 0;
  > div {
    position: relative;
    padding: 40px;
    border-radius: 100%;
    border: 1px solid #2e2c2c;
    @media only screen and (max-width: 500px) {
      padding: 25px;
    }
    &.earned {
      background-image: url("../../assets/images/loyalty/coffee.png");
      background-size: cover;
    }
    &.gray {
      // background-image: url("../../assets/images/loyalty/coffee-gray.png");
      background-size: cover;
    }
    &.obscure {
      opacity: 0.4;
    }
    .free {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      font-weight: 400;
      font-size: 1.5rem;
      display: flex;
      justify-content: center;
      align-items: center;

      @media only screen and (max-width: 500px) {
        font-size: 1rem;
      }
    }
  }
}
</style>
